import StatsRule from "../../../../common/stats-rule";
import FootballStatsCategory from "../../../stats/football-stats-category";

export default class CflTurnoverOnDownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            gameContext.down > gameContext.gameConfig.general.downs &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const {
            fieldPosition,
            homeTeamId,
            awayTeamId,
            gameConfig,
            homeTeamHasPossession
        } = gameContext;
        const { redZoneLength, fieldLength } = gameConfig.general;
        const isRedzone =
            (homeTeamHasPossession ? 0 : fieldLength) -
                fieldPosition * -gameContext.getFieldDirectionMultiplier() <=
            redZoneLength;
        const { currentPeriod, currentDriveId } = play.contextSnapshot;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: currentPeriod,
            teamId: homeTeamHasPossession ? awayTeamId : homeTeamId,
            playerId: null,
            driveId: currentDriveId,
            fragmentId: fragment.id,
            category: isRedzone
                ? FootballStatsCategory.TURNOVER_ON_DOWN_REDZONE
                : FootballStatsCategory.TURNOVER_ON_DOWN,
            values: {
                completed: 1
            }
        });
    }
}
